import { NAVIGATION_ROUTES } from "./NavigationUtils"

export const handleExpiredTokenError = (error_response, navigate) => {
    if (error_response?.message?.includes("expire")) {
        navigate(NAVIGATION_ROUTES?.LOGIN)
        return
    }
    return
}